/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit, Input, Injectable, EventEmitter, Output, Inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { IcecontrolSettings, IcecontrolPermission, iceColumnDefinition } from '../../components/models/icesettings';
import { userTypes } from '../../login/login.config';
import { IcematgridComponent } from '../icepanel/icematgrid.component';
import { IcepanelComponent } from '../icepanel/icepanel.component';

@Component({
	selector: 'icesingleupload',
  templateUrl: './icesingleupload.component.html',
  styleUrls: ['./icesingleupload.component.scss'],
  providers: [IcematgridComponent]
})
@Injectable()

export class IcesingleUploadComponent implements OnInit {
  // Input Members
  @Input() placeholder: string = "";
  @Input() id: string = "";
  @Input() properties: any = {};
  @Input() ctrl: IcecontrolSettings = null;
  @Input() tableColumn: iceColumnDefinition = null;
  @Input() tableRowData: any = null;
  @Input() matTableObject: IcematgridComponent = null;

  // Output Members
  @Output() controlChange: EventEmitter<any> = new EventEmitter<any>();

  // Data Members
  iceFormControl: FormControl = null;
  permission: IcecontrolPermission = null;

  constructor(@Inject(IcepanelComponent) private parent: IcepanelComponent) {
	}

  ngOnInit() {
    try {
      this.permission = this.ctrl.permissions ? this.ctrl.permissions : new IcecontrolPermission(userTypes.USER_FEATURES.ufNone, userTypes.USER_FEATURE_ACCESS.ufaNone);
      if (this.matTableObject && this.tableRowData != null && this.tableColumn != null) {
        // tables should not use the standard formcontrol
        let formRowGroup: FormGroup = this.matTableObject.getFormGroup(this.tableRowData);
        this.iceFormControl = new FormControl(this.tableRowData[this.tableColumn.columnName]);
        formRowGroup.addControl(this.tableColumn.columnName, this.iceFormControl);
      }
      else if (this.ctrl == null) {
        this.iceFormControl = new FormControl(''); // No control so we create a placeholder control to prevent an errors
      }
      else {
        this.iceFormControl = this.ctrl.getFormControl();
        if (this.iceFormControl == null)
          this.iceFormControl = new FormControl(''); // No control so we create a placeholder control to prevent an errors
      }

      if (this.permission.default_access === userTypes.USER_FEATURE_ACCESS.ufaReadOnly) {
        this.iceFormControl.disable();
      }
    }
    catch (e) {
      console.log(e);
    }
  }

  ngOnDestroy() {
  }

  isReadonly(): boolean {
    if (this.ctrl == null) return false;

    return this.ctrl.getReadonly();
  }

  isDisabled(): boolean {
    if (this.ctrl == null || this.permission == null) return false;

    if (this.ctrl.getDisabled()) return true;

    return this.permission.default_access === userTypes.USER_FEATURE_ACCESS.ufaReadOnly;
  }

  onClick(event: any) {
  }

  onSelectFile(event: any) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      var fileToUpload = event.target.files[0];
      reader.onload = (loadEvent) => {
        this.iceFormControl.setValue(fileToUpload);

        if (this.tableRowData != null && this.tableColumn != null && this.parent && this.parent.controlChange) {
          event.singleUploadSettings = this.tableColumn;
          this.tableRowData[this.tableColumn.columnName] = fileToUpload;
          event.tableColumn = this.tableColumn;
          event.tableRowData = this.tableRowData;
          this.parent.onControlChange(event);
        }
        else if (this.parent && this.parent.controlChange) {
          event.singleUploadSettings = this.ctrl;
          this.parent.onControlChange(event);
        }
        else {
          event.singleUploadSettings = this.ctrl;
          this.controlChange.emit(event);
        }
      }
      reader.readAsDataURL(event.target.files[0]); // read file as data url
    }
  }

  getFile(): any {
    if (this.iceFormControl == null) return null;
    if (this.iceFormControl.value instanceof File) return this.iceFormControl.value;
    return null;
  }
}
